import { proxy } from 'valtio'
import type { Tenant } from '@domain/entities'

export interface TenantState {
  tenants: Tenant[]
  isLoaded: boolean
}

export const tenantStore = proxy<TenantState>({
  tenants: [],
  isLoaded: false,
})

export const tenantActions = {
  setTenants(tenants: Tenant[]) {
    tenantStore.tenants = tenants
    tenantStore.isLoaded = true
  },

  getTenantName(id: string | undefined): string {
    if (!id) return '—'
    const tenant = tenantStore.tenants.find((t) => t.id === id)
    return tenant?.name ?? id.slice(0, 8) + '...'
  },
}
